import React, { Component, PropTypes } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Project from '../components/Project';

import { connect } from 'react-redux';
const { Link } = require('react-router')
//Change Class per Project
class HighlyRelevant extends React.Component {
  render () {
    const { projects, benchmark, personalInfo } = this.props;  
    console.log(personalInfo);
    
    const featProject = projects[4];

    // const params = this.props.params || {}
    // const { title, description, year, poster, trailer } = params
    return (
      <div className='container'>
        <Header personalInfo={personalInfo} />
        <div className=''>

          <div className='back-button'>
          <Link to='/'>
          <span className="glyphicon glyphicon-chevron-left"></span>
            Back to projects
          </Link>
          </div>

          <Project project={featProject}/>


        </div>

        <div className='case-study col-md-12 col-xs-12'>

        <h1>
        Overview
        </h1>

        <p>
        Highly Relevant is a online marketing agency specializing in high profile entertainment clients such as Lucky Strike Bowling
        and Marquee Las Vegas.
        </p>

        <p>
        My role there was to closely work with the marketing team on multiple client sites to revamp their online presence. 

        </p>

        </div>
        <Footer personalInfo={personalInfo} />
      </div>
    )
  }
}

const { object, array } = React.PropTypes

HighlyRelevant.propTypes = {
  projects: PropTypes.array.isRequired,
  personalInfo: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.projects,
    personalInfo: state.personalInfo
  };
}

//Change for each project

export default connect(mapStateToProps)(HighlyRelevant)




/** WEBPACK FOOTER **
 ** ./src/pages/HighlyRelevant.js
 **/